import { Injectable } from '@angular/core';
import { Backend } from '../../_models/backend';
import TeacherType = Backend.TeacherType;

@Injectable({
  providedIn: 'root'
})
export class GlobalSharedService {

  // ---------- SHARED GLOBAL DATA BETWEEN COMPONENTS (TEACHER, BOARD, ADMIN ....)----------

  // app version
  appVersion: string | null = null;
  isVersionModalOpen = false;
  updateVersionLater = false;

  // account type
  accountType: TeacherType | null | undefined;

  // fullscreen
  inFullscreen = false;

  constructor() { }

  isSchoolAccount(): boolean {
    return this.accountType == null || this.accountType === 'SCHOOL';
  }

  isKidsAccount(): boolean {
    return this.accountType != null && this.accountType === 'PRESCHOOL';
  }

  isProAccount(): boolean {
    return this.accountType != null && this.accountType === 'BUSINESS';
  }

  showLicenceWarning(showLicenceWarning: boolean): void {
    if (showLicenceWarning) {
      const watermark = document.getElementById('watermark');
      if (watermark != null) {
        watermark.style.display = 'block';
      }
    }
  }

  // fullscreen

  changeFullScreenMode(elementId: string): void {
    const d = document as any;
    if (d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement) {
      if (d.exitFullscreen) {
        d.exitFullscreen();
      } else if (d.mozCancelFullScreen) { /* Firefox */
        d.mozCancelFullScreen();
      } else if (d.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        d.webkitExitFullscreen();
      } else if (d.msExitFullscreen) { /* IE/Edge */
        d.msExitFullscreen();
      }
    } else {
      const elem = document.getElementById(elementId) as any;
      if (elem) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen();
        }
      }
    }
  }

  isFullScreenSupported(elementId: string): boolean {
    const elem = document.getElementById(elementId) as any;

    return elem && (elem.requestFullscreen || elem.mozRequestFullScreen || elem.webkitRequestFullscreen || elem.msRequestFullscreen);
  }

  fullScreenChanged(): void { // ez mindenfajta fullscreen változást észlel (saját gombunk, google slide gomb, escape-re kilépés stb.)
    // document.fullscreenElement will point to the element that
    // is in fullscreen mode if there is one. If there isn't one,
    // the value of the property is null.
    const doc = document as any;
    if (doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement) {
      this.inFullscreen = true;
    } else {
      this.inFullscreen = false;
    }
  }
}
